import React from 'react';
import { StatisticsLayout } from 'views/components';
import { downloadHeaders } from './fixtures';
import isEmpty from 'lodash/isEmpty';
import { statisticsActions } from 'core/Statistics';
import { useTranslation } from 'react-i18next';
import {
    BarChart,
    Card,
    InfoCard,
    PieChart
} from 'mol-ui';
import {
    Col,
    Row
} from 'reactstrap';
import {
    isLocked,
    objectToChart,
    parsePreworkAptitude,
    parsePreworkType,
    parseSelect
} from 'shared/utils';
import {
    useDispatch,
    useSelector,
    useWindowSize
} from 'hooks';

const StatisticsPreworks = () => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { xs } = useWindowSize();
    const { user } = useSelector('account');
    const {
        preworks,
        preworksDownload,
        preworksDownloading,
        loading
    } = useSelector('statistics');

    const onFiltersChange = filters => {
        dispatch(statisticsActions.getStatisticsPreworks(filters));
    };

    const {
        total = 0,
        total_finalized = 0,
        total_results,
        total_test = [],
        total_type
    } = preworks;
    const parsedTests = parseSelect(total_test);

    const downloadController = {
        data: preworksDownload,
        downloading: preworksDownloading,
        fileName: t('Controles ocupacionales'),
        headers: downloadHeaders.filter(({ hidden }) => !hidden),
        onDownload: filters => dispatch(statisticsActions.getStatisticsPreworksDownload(filters))
    };

    const resultsConfig = {
        config: [{ dataKey: 'value', fontSize: xs ? '11px' : '12px', label: t('Resultado') }],
        data: objectToChart(total_results ?? {}, parsePreworkAptitude),
        height: 300,
        minWidth: 600
    };

    const typeConfig = {
        config: [{ dataKey: 'value', fontSize: xs ? '11px' : '12px', label: t('Estado') }],
        data: objectToChart(total_type ?? {}, parsePreworkType),
        height: 300,
        minWidth: 600
    };

    return (
        <StatisticsLayout
            downloadController={ !isLocked(user, 'download_reports') ? downloadController : undefined }
            filterPatients={ false }
            loading={ loading }
            title={ t('Controles ocupacionales') }
            onFiltersChange={ onFiltersChange }
        >
            <Row>
                <Col md="6" xs="12">
                    <InfoCard
                        caption={ t('Controles realizados') }
                        icon="summarize"
                        title={ (total ?? 0).toString() }
                    />
                </Col>
                <Col md="6" xs="12">
                    <InfoCard
                        caption={ t('Controles finalizados') }
                        icon="done"
                        title={ (total_finalized ?? 0).toString() }
                    />
                </Col>
                <Col md="6" xs="12">
                    <Card overflowX="auto" title={ t('Por tipo de evaluación') }>
                        <PieChart { ...typeConfig } />
                    </Card>
                </Col>
                <Col md="6" xs="12">
                    <Card overflowX="auto" title={ t('Por resultado del examen') }>
                        <PieChart { ...resultsConfig } />
                    </Card>
                </Col>
                {
                    !isEmpty(parsedTests) &&
                    <Col xs="12">
                        <Card margin="10px 0px 0px 0px" padding="10px">
                            <BarChart
                                vertical
                                config={ [{ dataKey: 'qty', label: t('Pruebas realizadas') }] }
                                data={ parsedTests }
                                xAxisVerticalHeight={ 100 }
                            />
                        </Card>
                    </Col>
                }
            </Row>
        </StatisticsLayout>
    );
};

export default StatisticsPreworks;
